import styles from "@/components/dataVisualization/metricBreakdownTable.module.css";

export interface MetricBreakdownRow {
  id: string;
  label: string;
  value: number;
  percentage: number;
  color?: string;
}

interface Props {
  rows: MetricBreakdownRow[];
  labelHeader: string;
  valueHeader: string;
  percentageHeader: string;
  totalLabel?: string;
  totalValue?: number;
  totalPercentage?: number;
  valueFormatter?: (value: number) => string;
  percentageFormatter?: (value: number) => string;
  className?: string;
}

export default function MetricBreakdownTable({
  rows,
  labelHeader,
  valueHeader,
  percentageHeader,
  totalLabel,
  totalValue,
  totalPercentage,
  valueFormatter = (value) => String(value),
  percentageFormatter = (value) => `${value}%`,
  className,
}: Props) {
  const shouldRenderTotalRow =
    totalLabel !== undefined &&
    totalValue !== undefined &&
    totalPercentage !== undefined;

  return (
    <div className={`${styles.container} ${className ?? ""}`.trim()}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{labelHeader}</th>
            <th>{valueHeader}</th>
            <th>{percentageHeader}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>
                <span className={styles.labelCell}>
                  {row.color ? (
                    <span
                      className={styles.dot}
                      style={{ backgroundColor: row.color }}
                    />
                  ) : null}
                  {row.label}
                </span>
              </td>
              <td>{valueFormatter(row.value)}</td>
              <td>{percentageFormatter(row.percentage)}</td>
            </tr>
          ))}
          {shouldRenderTotalRow ? (
            <tr className={styles.totalRow}>
              <td>{totalLabel}</td>
              <td>{valueFormatter(totalValue)}</td>
              <td>{percentageFormatter(totalPercentage)}</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
